import i18next from 'i18next';

i18next.addResources('es', 'EmailError', {
  required: 'Requerido',
  quantity: 'Cantidad máxima de emails',
  invalid: 'El email ingresado no es correcto',
  exists: 'El email ingresado ya existe'
});
